import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { exitDemo, isDemoMode } from '../../demo/core';

/** Ops product accent (DESIGN.md). */
const OPS_ACCENT = '#F4841A';

/** Thin sticky bar shown only in demo mode: sample-data notice + Exit demo. */
const DemoBanner: React.FC = () => {
  const { t } = useTranslation();
  if (!isDemoMode()) return null;

  return (
    <Box
      role="status"
      sx={(theme) => ({
        position: 'sticky',
        // Below the fixed mobile AppBar on xs; flush with the top from sm up.
        top: { xs: 56, sm: 0 },
        zIndex: theme.zIndex.appBar - 1,
        minHeight: 36,
        bgcolor: OPS_ACCENT,
        color: '#FFFFFF',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'wrap',
        columnGap: 2,
        rowGap: 0.5,
        px: 2,
        py: 0.5,
      })}
    >
      <Typography variant="body2" sx={{ fontWeight: 500, color: 'inherit' }}>
        {t('demo.banner')}
      </Typography>
      <Button
        size="small"
        variant="outlined"
        color="inherit"
        onClick={() => exitDemo()}
        sx={{ py: 0, minHeight: 26, borderColor: 'rgba(255,255,255,0.7)', '&:hover': { borderColor: '#FFFFFF', bgcolor: 'rgba(255,255,255,0.12)' } }}
      >
        {t('demo.exit')}
      </Button>
    </Box>
  );
};

export default DemoBanner;
